export default { 
  Auth: require('./auth').default,
  Dashboard: require('./Dashboard').default,
  Program: require('./program').default,
  Errors: require('./errors').default,
  Programs: require('./programs').default,
  User: require('./user').default,
  Certif: require('./certificate').default,
  Import: require('./import').default,
  Manage: require('./manage-certif').default,
  Discusstion: require('./discussion').default,
}
